<template>
  <div class="base-input-skeleton">
    <STextSkeleton v-if="label" :font-size="fontSize" width="14rem" />
    <PSkeleton v-if="description" height="1.5rem" />

    <slot name="input" />

    <STextSkeleton v-if="subtext" width="120px" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { BaseInputSkeletonProps } from "@/molecules/baseInput.ts";

import PSkeleton from "@/atoms/PSkeleton.vue";
import STextSkeleton from "@/atoms/STextSkeleton.vue";

const props = withDefaults(defineProps<BaseInputSkeletonProps>(), {
  size: "md",
});

const fontSize = computed(() => {
  if (props.size === "md") {
    return "base";
  }
  return props.size;
});
</script>

<style lang="postcss">
.base-input-skeleton {
  @apply flex flex-col gap-2;
}
</style>
